export default __webpack_public_path__ + "static/media/a011-09.f6789163.jpg";